/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleSummary {
    getFixupPrototypeFunction() { return RoleSummary.fixupPrototype; }

    static newInstance(model: Partial<RoleSummary>): RoleSummary {
        let obj = Object.assign(new RoleSummary(), model);
        RoleSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleSummary>): RoleSummary {
        if (!model) return null;
        return RoleSummary.newInstance(<RoleSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleSummary) {
        if (!obj) return;

        models.RoleSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleSummary): boolean {
        Object.setPrototypeOf(obj, RoleSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the Role
     */
    name: string;

    /**
     * Type of the Role
     */
    role_type: string;

    /**
     * Role category
     */
    category: models.RoleCategory;

    /**
     * ID of the tenant
     */
    tenant_id: string;

}
